'use client';

import { useEffect } from 'react';

/**
 * Client-side Sentry initialization component
 * This ensures Sentry loads on the client side
 */
export function SentryInit() {
  useEffect(() => {
    // Dynamically import sentry.client.config to ensure it runs on client
    import('../sentry.client.config').catch((err) => {
      console.error('[Sentry] Failed to load client config:', err);
    });
  }, []);

  return null;
}
